<template>
  <!--begin::Navbar-->

  <div class="row">
    <div v-if="pgLoading">
      <Loading />
    </div>
    <div class="col-12 text-center">
      <div id="invoice" class="invoice min-vh-70">
        <div v-if="item.company" class="invoice-code">
          <div :class="logoClassName" class="text-center">
            <img :src="item.company.image" style="display: block" />
          </div>
        </div>
        <div v-if="item.company" class="invoice-content">
          <div :class="className">
            <p class="invoice-title">{{ $t('app.customer_name') }}: </p>
            <p>{{ item.user.name }}</p>
          </div>
          <div :class="className">
            <p class="invoice-title">{{ $t('app.customer_phone') }}: </p>
            <p style="direction: ltr">{{ item.user.countryCode+item.user.mobile }}</p>
          </div>
          <div :class="className">
            <p class="invoice-title">{{ $t('app.amount') }}: </p>
            <p>{{ item.amount + " " + $t('app.' + item.currency) }}</p>
          </div>
          <div :class="className">
            <p class="invoice-title">{{ $t('app.beneficiary_name') }}: </p>
            <p>{{  ($i18n.locale == 'en') ? item.company.en.name : item.company.ar.name }}</p>
          </div>
          <div :class="className">
            <p class="invoice-title">{{ $t('app.subject') }}: </p>
            <p>{{ item.title }}</p>
          </div>
          <div :class="className">
            <p class="invoice-title">{{ $t('app.details') }}: </p>
            <p>{{ item.body }}</p>
          </div>
          <div class=" pt-4 pay_now">
            <button v-if="item.expired == 0" class="btn btn-primary w-50" @click="goToLink">{{ $t('app.pay_now')
              }}</button>
            <button v-if="item.expired == 1" class="btn btn-primary w-50" @click="goToLink">{{ $t('app.print')
              }}</button>
            <p class="badge text-danger" v-if="item.expired == 2">{{ $t('app.payment_link_is_expired') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="redirect-message">
    Please wait while you are redirected to the gateway to make payment...
  </div> -->
</template>
<script>
import Loading from "@/components/Loading.vue";

export default {
  name: 'index',
  components: { Loading },
  data: function () {
    return {
      direction: localStorage.getItem('locale') == "ar" ? "rtl" : "ltr",
      className: localStorage.getItem('locale') == "ar" ? "text-end" : "text-start",
      logoClassName: localStorage.getItem('locale') == "ar" ? "text-start" : "text-end",
      url: '',
      pgLoading: false,
      item: {
        expired: "",
        company: null
      },
    }
  },
  created() {
    this.fetchInvoice();
  },
  mounted() {
    if (localStorage.getItem('locale') == 'ar') {
      document.getElementById("invoice").classList.add('is-rtl');
    }
  },
  methods: {
    fetchInvoice() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + '/invoices/find/' + this.$route.params.code,
        method: 'GET',
        headers: {
          appId: process.env.VUE_APP_APPID
        },
        data: {}
      }
      this.axios(options)
        .then(res => {
          // console.log(res?.data?.data)
          this.pgLoading = false;
          this.url = res.data.data.link;
          if (res.data.data.expired == "1") {
            this.goToLink();
          } else {
            this.item = res.data.data;
          }
        })
        .catch(() => {
          this.pgLoading = false;
        })
        .finally(() => {
        });
    },
    goToLink() {
      window.location.replace(this.url);
    }
  }
}

</script>

<style>
.pay_now,
.pay_now .btn {
  text-align: center !important;
}

.invoice {
  width: 340px;
  padding: 10px;
  background-color: hsl(0, 0%, 100%);
  border-radius: 20px;
  box-shadow: 0 0 8px rgba(30, 30, 30, 0.1);
  cursor: pointer;
  transition: transform 0.3s;
  margin: 5% auto;
}

.invoice-code {
  background-color: #f5f8fa;
  display: flex;
  justify-content: center;
  padding: 20px;
  border-radius: 10px;
  transition: transform 0.3s;
}

.invoice-code img {
  width: 85px;
  height: 85px;
  display: inline-block !important;
}

.invoice-content {
  padding: 20px;
  text-align: center;
  transition: padding 0.3s;
}

p {
  display: inline-block;
  font-weight: 400;
  font-size: 14px;
}

.invoice-title {
  color: hsl(218, 44%, 22%);
  margin-bottom: 20px;
  display: inline-block;
  width: 45%;
}
</style>

<!-- <style>
.redirect-message {
  position: fixed;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100% !important;
  z-index: 1000000 !important;
  background: #fff;
  color: #000;
  padding: 5px 10px;
}
</style> -->